export default __webpack_public_path__ + "static/stringywaxblobs-ac1b0f8d5a3d859cc24c19d57c832987.png";